import { FormService } from './form.service';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { ServerResponse } from './../interfaces/server-response.model';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import { CustomDSValidators } from '../shared/validators/custom-validators';
@Injectable()
export class ResponseService {

  private ERROR_TITLE_KEY: string = 'GENERAL.UPS';
  private SUCCESS_TITLE_KEY: string = 'GENERAL.SUCCESS';

  constructor(
    private translateService: TranslateService,
    private notificationsService: NotificationsService,
    private localStorageService: LocalStorageService,
    private formService: FormService,
    private router: Router
  ) { }

  /**
   * Wyswietla toast z informacja o prawidlowym wykonaniu
   * 
   * @param {Boolean} showNotification 
   * @param {ServerResponse} response 
   * @param {string} [key] 
   * @returns {*} 
   * 
   * @memberof ResponseService
   */
  public success(showNotification: Boolean, response: ServerResponse, key?: any, operation?: string): any {
    const code = response.status.code;
    if (code === 401) {
      this.router.navigateByUrl('/login');
      return false;
    }

    if (showNotification) {
      let messageKey: string = 'RESPONSE.' + response.status.message.toUpperCase();
      messageKey = operation ? messageKey + '.' + operation.toUpperCase() : messageKey;
      const translatedMessages = this.translateService.instant([this.SUCCESS_TITLE_KEY, messageKey]);
      this.notificationsService.success(translatedMessages[this.SUCCESS_TITLE_KEY], translatedMessages[messageKey]);
    }

    return (response.data) ? key ? response.data[key] : response.data : true;
  }

  /**
   * Wyswietla toast z bledem
   * 
   * @param {ServerResponse} response 
   * @returns {*} 
   * 
   * @memberof ResponseService
   */
  public error(response: ServerResponse, form?: any, operation?: string): any {
    if (response.status.message === 'validation.failed') {
      for (let key in response.data.errors) {
        for (let errors of response.data.errors[key]) {
          if (form !== undefined) {
            let errorStructure = errors.split('.');
            let errorType = errorStructure[1];
            switch (errorType) {
              case 'unique':
              case 'exists':
              case 'domain_exists':
              case 'invalid_password': {
                if(this.formService.validators == undefined)
                {
                  this.formService.validators = {};
                }
                if(!this.formService.validators.hasOwnProperty(key))
                {
                  this.formService.validators[key] = [];
                }

                this.formService.validators[key].push(CustomValidators.notEqual(form.controls[key].value));
                break;
              }
              // case 'cname_exists_name':
              //   this.formService.validators[key].push(CustomDSValidators.cnameExistsName);
              //   break;
              // case 'ipv4':
              //   this.formService.validators[key].push(CustomDSValidators.IP);
              //   break;
              // case 'ipv6':
              //   this.formService.validators[key].push(CustomDSValidators.IPv6);
              //   break;
              // case 'required':
              //   this.formService.validators[key].push(Validators.required);
              //   break;
              case 'domain_name':
                this.formService.validators[key].push(CustomDSValidators.domain_name);
                break;
              // case 'record_value':
              //   this.formService.validators[key].push(CustomDSValidators.record_value);
              //   break;
              // case 'numeric':
              //   this.formService.validators[key].push(CustomDSValidators.default_ttl);
              //   break;
              // case 'max':
              //   this.formService.validators[key].push(CustomDSValidators.maxPortNumber8444);
              //   break;
              default:
                break;
            }
            form.controls[key].setValidators(this.formService.validators[key]);
            form.controls[key].updateValueAndValidity();
          }
        }
      }
    } else if (response.data && response.data.status && response.data.status == 'error' && response.data.message) {
      this.notificationsService.error('Wystąpił problem', response.data.message);
    } else {
      
      let messageKey: string = 'RESPONSE.' + response.status.message.toUpperCase();
      messageKey = operation ? messageKey + '.' + operation.toUpperCase() : messageKey;
      const translatedMessages = this.translateService.instant([this.ERROR_TITLE_KEY, messageKey]);
      this.notificationsService.error(translatedMessages[this.ERROR_TITLE_KEY], translatedMessages[messageKey]);
      switch (messageKey) {
        case 'RESPONSE.CONTRACT.NOT_FOUND': this.router.navigateByUrl('/contracts/list'); break;
        case 'RESPONSE.CONTRACT.ENDED': this.router.navigateByUrl('/contracts/list'); break;
        case 'RESPONSE.COMPANY.NOT_FOUND': this.router.navigateByUrl('/company/select'); break;
        case 'RESPONSE.CONTRACT.ITEM.NOT_FOUND': this.router.navigateByUrl('/contracts/list'); break;
        case 'RESPONSE.CONTRACT.ITEM.PERMISSION_DENIED': this.router.navigateByUrl('/contracts/list'); break;
        // case 'RESPONSE.COMPANY.ACCESS': this.router.navigateByUrl('/panel'); break;
        case 'RESPONSE.MESSAGE.ACCESS_DENIED': this.router.navigateByUrl('/messages/list'); break;
        case 'RESPONSE.GLOBAL.CSRF_TOKEN_MISMATCH': location.reload(); break;
        case 'RESPONSE.GLOBAL.UNAUTHENTICATED': this.router.navigateByUrl('/login'); break;
        case 'RESPONSE.USER.NOT_VALIDATED': this.router.navigateByUrl('/login/verify'); break;
      }

      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/response.service.ts